import { CheckedRepair } from "../../../model/CheckedRepair";
import { ListResponse } from "../../../model/common/ListResponse";
import { Holiday } from "../../../model/Holiday";
import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";
import { HttpResponse } from "../../../network/types";
import {
  GetHolidayRequestBody,
  CheckRepairShopBusinessRequestBody,
  EditRepairShopBusinessRequestBody,
} from "./types";

export const editRepairShopBusiness = async (
  requestBody: EditRepairShopBusinessRequestBody
) => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.PUT,
    url: `/repair-shops/me/business`,
    requestBody,
  });

  return response;
};
export const checkRepairShopBusiness = async (
  requestBody: CheckRepairShopBusinessRequestBody
): Promise<CheckedRepair> => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url: `/repair-shops/this/repairs/checked`,
    requestBody,
  });
  return response?.data.row;
};
export const getHolidays = async (
  queryParams: GetHolidayRequestBody
): Promise<ListResponse<Holiday>> => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url: `/ministry-governments/public-holiday`,
    queryParams,
  });
  return {
    rows: response?.data.rows,
    count: response?.data.count,
  };
};
